module.exports = __webpack_public_path__ + "media/images/sp/top/recommend-plan-wedding1-05688dde98e3691742cab8dd31922194.jpg";